import LaptopHello from '../../../assets/images/LaptopHello.png';
import StandingHello from '../../../assets/images/StandingHelllo.png';
import RocketHello from '../../../assets/images/RocketHello.png';
import UpsideHello from '../../../assets/images/UpsideHello.png';
import GetInTouch from './GetInTouch';
import AnimatedImages from '../../landingPage/home/AnimatedImages';

const leftImages = [
  { src: LaptopHello, alt: 'Code 3D', className: 'code3d', height: '12rem' },
  {
    src: StandingHello,
    alt: 'Smiling Robot',
    className: 'smilingRobot',
    height: '11rem',
  },
];

const rightImages = [
  { src: RocketHello, alt: 'rocket', className: 'rocket', height: '12rem' },
  { src: UpsideHello, alt: 'API', className: 'API', height: '12rem' },
];

const Contact = ({ id }) => {
  return (
    <div
      id={id}
      className="relative flex flex-col h-[80vh] lg:min-h-[110vh] mt-0 overflow-hidden"
    >
      <div className="relative flex-grow">
        <div className="absolute inset-0 overflow-hidden items-center">
          
          {/* Floating mascot images strictly in the background */}
          <div className="desktop-only absolute inset-0 z-0 pointer-events-none">
            <AnimatedImages side="left" images={leftImages} />
            <AnimatedImages side="right" images={rightImages} />
          </div>

          {/* Main Get In Touch card in foreground */}
          <div className="relative z-10">
            <GetInTouch />
          </div>

        </div>
      </div>
    </div>
  );
};

export default Contact;

